enum WarrantySelection {
  OneYear = 'one-year',
  TwoYear = 'two-year',
  ThreeYear = 'three-year',
}

export default WarrantySelection;
